import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import BlockRightImage from "../components/BlockRightImage";
import Accordion from "../components/Accordion";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import Block3Columns from "../components/Block3Columns";
import { motion } from "framer-motion";
import {
  DistanciaContinuos,
  PresencialInscripcion,
  PresencialNuevos,
  PresencialContinuos,
  PosgradoPostulacion,
  PosgradoNuevos,
  DistanciaNuevos,
} from "../components/Pasos";
import BannerGeneral from "../components/BannerGeneral";
import EnLineaPagos from "../components/Enlineapagos";
import PosgradoPagos from "../components/PosgradoPagos";
import PresencialPagos from "../components/PresencialPagos";

function Matriculas() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div className="wrapper-matricula">
            {data.map((item, index) => (
              <div key={index}>
                <div className="layout6">
                  <center>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />{" "}
                  </center>
                </div>

                <div id="enlinea">
                  <BlockRightImage
                    src={item.field_imagen1}
                    alt="utpl"
                    content={
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque1,
                          }}
                        />{" "}
                        <div>
                          <Accordion
                            title="Fechas de matrícula"
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque2,
                                  }}
                                />
                              </>
                            }
                          ></Accordion>

                          <Accordion
                            title="Calendario académico"
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque3,
                                  }}
                                />
                              </>
                            }
                          ></Accordion>
                        </div>
                        <br></br>
                        <DistanciaNuevos></DistanciaNuevos>
                        <DistanciaContinuos></DistanciaContinuos>
                      </>
                    }
                  ></BlockRightImage>
                  <div className="padding2">
                    <EnLineaPagos></EnLineaPagos>
                  </div>
                </div>
                <div className="lightbluebg " id="presencial">
                  <div>
                    <BlockRightImage
                      src={item.field_imagen4}
                      alt="utpl"
                      content={
                        <>
                          {" "}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque4,
                            }}
                          />{" "}
                          <div>
                            <Accordion
                              title="Fechas de matrícula"
                              content={
                                <>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque5,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                            <Accordion
                              title="Calendario académico"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque6,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                          </div>
                          <PresencialInscripcion></PresencialInscripcion>
                          <PresencialNuevos></PresencialNuevos>
                          <PresencialContinuos></PresencialContinuos>
                        </>
                      }
                    ></BlockRightImage>
                    <div className="padding2">
                      <PresencialPagos></PresencialPagos>
                    </div>
                  </div>
                </div>
                <div id="posgrados">
                  <div>
                    <BlockRightImage
                      src={item.field_imagen7}
                      alt="utpl"
                      content={
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque7,
                            }}
                          />{" "}
                          <div>
                            <Accordion
                              title="Fechas de matrícula"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque8,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                            <Accordion
                              title="Calendario académico"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque9,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                          </div>
                          <PosgradoPostulacion></PosgradoPostulacion>
                          <PosgradoNuevos></PosgradoNuevos>
                        </>
                      }
                    ></BlockRightImage>
                  </div>

                  <div className="padding2">
                    <PosgradoPagos></PosgradoPagos>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/matriculas">Matrículas</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>

      <div className="layout6">
        <center>
          <h2>
            <b> ¡Matricúlate ahora</b> y descubre todo lo que necesitas saber
            sobre los enlaces de registro, fechas, procesos y calendario
            académico adaptado a tu programa de estudios!
          </h2>
          <p>
            Ya seas un estudiante nuevo o de segundo ciclo en adelante, aquí
            encontrarás todo lo necesario para planificar tu periodo académico.
          </p>
        </center>
      </div>

      <div className="indicator-icon">
        <Block3Columns
          col1={
            <a href="#enlinea" className="icon20">
              <br></br> <br></br>
              <h4>Carreras a distancia y en línea, carreras tecnológicas</h4>
              <motion.div
                className="icons"
                initial={{ y: 10 }}
                animate={{ y: 0, opacity: 0.8 }}
                transition={{ type: "spring", repeat: Infinity }}
              >
                <span className="material-icons">keyboard_arrow_down</span>
              </motion.div>
            </a>
          }
          col2={
            <a href="#presencial" className="icon20">
              <br></br> <br></br>
              <h4>Carreras presencial</h4>
              <motion.div
                className="icons"
                initial={{ y: 10 }}
                animate={{ y: 0, opacity: 0.8 }}
                transition={{ type: "spring", repeat: Infinity }}
              >
                <span className="material-icons">keyboard_arrow_down</span>
              </motion.div>
            </a>
          }
          col3={
            <a href="#posgrados" className="icon20">
              <br></br> <br></br>
              <h4>Posgrados</h4>
              <motion.div
                className="icons"
                initial={{ y: 10 }}
                animate={{ y: 0, opacity: 0.8 }}
                transition={{ type: "spring", repeat: Infinity }}
              >
                <span className="material-icons">keyboard_arrow_down</span>
              </motion.div>
            </a>
          }
        ></Block3Columns>
      </div>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-matriculas.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Matriculas;
